import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Box } from '@mui/material'
import {
  SettingsOutlined as GeneralIcon,
  VpnKeyOutlined as ApiKeysIcon,
  ExtensionOutlined as FeaturesIcon,
  HubOutlined as IntegrationsIcon,
  GroupsOutlined as TeamIcon,
  BarChartOutlined as UsageIcon,
  ReceiptOutlined as BillingIcon,
} from '@mui/icons-material'
import { integrationSubIcon } from '../icons/forgeBrandIcons'
import {
  getOrganizationIntegrationNavItems,
  getOrganizationNavItems,
  isOrganizationIntegrationsPath,
  isOrganizationNavItemActive,
  organizationIntegrationsPath,
  parseOrganizationIntegrationsSubPage,
  type OrgSettingsPage,
} from '../../utils/organizationSettingsNav'
import { NavItem } from './sidebarPrimitives'
import BetaTag from '../BetaTag'

function organizationNavIcon(page: OrgSettingsPage): React.ReactNode {
  switch (page) {
    case 'general':
      return <GeneralIcon />
    case 'api-keys':
      return <ApiKeysIcon />
    case 'features':
      return <FeaturesIcon />
    case 'integrations':
      return <IntegrationsIcon />
    case 'team':
      return <TeamIcon />
    case 'usage':
      return <UsageIcon />
    case 'billing':
      return <BillingIcon />
    default:
      return <GeneralIcon />
  }
}

export default function OrganizationContextNav({ onNavigate }: { onNavigate?: () => void }) {
  const navigate = useNavigate()
  const location = useLocation()
  const onIntegrations = isOrganizationIntegrationsPath(location.pathname)
  const activeIntegration = parseOrganizationIntegrationsSubPage(location.pathname)

  const go = (path: string) => {
    navigate(path)
    onNavigate?.()
  }

  return (
    <>
      {getOrganizationNavItems().map((item) => {
        if (item.page === 'integrations') {
          return (
            <React.Fragment key={item.page}>
              <NavItem
                text={item.label}
                icon={organizationNavIcon(item.page)}
                active={onIntegrations}
                onClick={() => go(organizationIntegrationsPath())}
              />
              {onIntegrations ? (
                <Box sx={{ ml: 1.5, borderLeft: '1px solid var(--vs-border-subtle)', pl: 0.5 }}>
                  {getOrganizationIntegrationNavItems().map((sub) => (
                    <NavItem
                      key={sub.subPage}
                      text={sub.label}
                      icon={integrationSubIcon(sub.subPage)}
                      active={activeIntegration === sub.subPage}
                      onClick={() => go(sub.path)}
                      pl={1.5}
                      fontSize="0.8125rem"
                      tag={sub.beta ? <BetaTag /> : undefined}
                    />
                  ))}
                </Box>
              ) : null}
            </React.Fragment>
          )
        }
        return (
          <NavItem
            key={item.page}
            text={item.label}
            icon={organizationNavIcon(item.page)}
            active={isOrganizationNavItemActive(location.pathname, item.path)}
            onClick={() => go(item.path)}
          />
        )
      })}
    </>
  )
}
